import { useCallback, useState } from "react";
import useAdminLoad from "../../../hooks/useAdminLoad";
import * as crmApi from "../api/crmApi";

/**
 * The practice's default capture form (`GET /api/crm/forms/default`, design §E.4):
 * fields toggles, the editable consent text and the embed snippet. `update` autosaves a
 * partial patch (one field or the consent text, on blur/toggle) and merges the server's
 * answer back in — `PUT /api/crm/forms/{id}` is expected to return the whole form, but a
 * refusal never has to be told apart from a stale read because the caller always awaits it.
 */
export default function useCaptureForm() {
  const [form, setForm] = useState(null);
  const load = useCallback(async () => { setForm(await crmApi.getDefaultForm()); }, []);
  const { loading, loadError, reload } = useAdminLoad(load);

  const update = useCallback(async (patch) => {
    const id = form?.id;
    const next = await crmApi.updateForm(id, patch);
    setForm(next);
    return next;
  }, [form]);

  const rotateKey = useCallback(async () => {
    const next = await crmApi.rotateFormKey(form?.id);
    setForm(next);
    return next;
  }, [form]);

  return { form, loading, loadError, reload, update, rotateKey };
}
